import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import AddIcon from '@mui/icons-material/Add';
import { City, Country, State } from "country-state-city";
import SettingSearchLocationByInputStudent from "../Institute/AddInstructor/Components/InstructorInfo/components/GooglePlacesApi/SettingSearchLocationByInputStudent";
import { SettingSelectList } from "../../Components/InputComps/InputComps";
import { CountryOptions } from "../Institute/AddInstructor/Components/OptionsArr/OptionsArr";
import axios from "axios";

const OwnerRegisteraion = ({setOpenSignupScreen, InstituteData, setInstituteData}) => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    const [emailError, setEmailError] = useState("");
    const [errors, setErrors] = useState({});
    const [cities, setCities] = useState([]);
    const [SelectedCoordinates, setSelectedCoordinates] = useState(null);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const validateEmailField = (e, fieldName) => {
    const value = e.target.value;
    // Update the field in the ownersData
    setInstituteData((prev) => ({
        ...prev,
        ownersData: {
        ...prev.ownersData,
        [fieldName]: value,
        },
    }));

    // Validate the email and update errors
    setErrors((prev) => ({
        ...prev,
        [fieldName]: emailRegex.test(value) ? "" : "Invalid email format",
    }));
    };

    const handleFileChange = (event, field) => {
        const file = event.target.files[0]; // Get the selected file
        if (!file) return; // Exit if no file is selected
    
        // Create a preview URL for display
        const previewURL = URL.createObjectURL(file);
    
        // Update state to store both the file and the preview URL
        setInstituteData((prevState) => {
            const newState = { ...prevState };
    
             if (field in prevState.ownersData) {
                newState.ownersData[field] = {
                    file,
                    previewURL
                };
            }
    
            return newState;
        });
    };
     
    // const validatePhoneNumber = (value, field) => {
    //     const newErrors = { ...errors }; // Copy existing errors
    
    //     // Ensure number starts with +1
    //     let formattedValue = value.startsWith('1') ? `+${value}` : value;
    
    //     // Remove spaces, dashes, and other characters
    //     formattedValue = formattedValue.replace(/[^\d+]/g, '');
    
    //     if (!/^\+1\d{10}$/.test(formattedValue)) {
    //         newErrors[field] = "Invalid Phone number ";
    //     } else {
    //         delete newErrors[field]; // Remove error if valid
    //     }
    
    //     setErrors(newErrors);
    //     return formattedValue; // Store the correctly formatted number
    // };
    
    // Function to update phone number in state and validate
    // const handlePhoneNumberChange = (value, field) => {
    //     const validatedNumber = validatePhoneNumber(value, field);
    //     setInstituteData((prev) => ({
    //         ...prev,
    //         ownersData: { ...prev.ownersData, [field]: validatedNumber },
    //     }));
    // };  

    const validatePhoneNumber = (value, field, country) => {
        const newErrors = { ...errors };
    
        let formattedValue = value.replace(/[^\d]/g, ''); // remove non-digits
    
        // Ensure +1 for US/Canada
        if (country?.dialCode === "1" && !formattedValue.startsWith("1")) {
            formattedValue = "1" + formattedValue;
        }
        if (country?.dialCode === "1") {
            formattedValue = "+" + formattedValue;
        }
    
        const countryCode = country?.dialCode;
    
        // Validate only for US/Canada
        if (countryCode === "1") {
            if (!/^\+1\d{10}$/.test(formattedValue)) {
                newErrors[field] = "Invalid Phone Number ";
            } else {
                delete newErrors[field];
            }
        } else {
            delete newErrors[field]; // No validation for other countries
        }
    
        setErrors(newErrors);
        return formattedValue;
    };

    const handlePhoneNumberChange = (value, field, country) => {
        const validatedNumber = validatePhoneNumber(value, field, country);
        setInstituteData((prev) => ({
            ...prev,
            ownersData: { ...prev.ownersData, [field]: validatedNumber },
        }));
    };
    
    const handleInputChange = (e, field) => {
        setInstituteData((prev) => ({
            ...prev,
            ownersData: {
                ...prev.ownersData,
                [field]: e.target.value,
            },
        }));
    };

    useEffect(() => {
        const selectedCountry = InstituteData?.ownersData?.country;
        console.log("selected country set in new location is:",selectedCountry)
        const selectedProvince = InstituteData?.ownersData?.province;
        console.log("selected selectedProvince set in new location is:",selectedProvince)
        if (
          typeof selectedCountry === "string" &&
          typeof selectedProvince === "string"
        ) {
          const country = Country?.getAllCountries()?.find(
            (country) =>
              country?.name.toLowerCase() === selectedCountry?.toLowerCase()
          );
          if (country) {
            const states = State?.getStatesOfCountry(country?.isoCode);
            const selectedProvinceData = states?.find(
              (province) =>
                province.name.toLowerCase() === selectedProvince?.toLowerCase()
            );
            if (selectedProvinceData ) {
              console.log("Found Province: ", selectedProvinceData);
              const citiesData = City.getCitiesOfState(
                country?.isoCode,
                selectedProvinceData?.isoCode
              );
              setCities(citiesData);
            }
          }
        }
      }, [InstituteData]);

    const ProvinceOptions = () => {
        let states = [];
    
        // Determine the country to use
      const countryName = InstituteData?.ownersData?.country;
    
        if (typeof countryName  === "string") {
          let countries = Country?.getAllCountries();
    
          const country = countries?.find(
            (country) =>
              country?.name.toLowerCase() ===
              countryName.toLowerCase()
          );
    
          if (country) {
            states = State?.getStatesOfCountry(country?.isoCode);
            // console.log("country", states);
          }
        }
    
        console.log("States", states);
        return states?.map((country) => (
          <option value={country.name} key={country.isoCode}>
            {country?.name}
          </option>
        ));
      };

    const CityOptions = () => {
    return (
        cities &&
        cities?.map((city, index) => (
        <option value={city?.name} key={index}>
            {city?.name}
        </option>
        ))
    );
    };

    const fetchLocationData = async (postalCode) => {
        try {
            console.log("Fetching data for postal code:", postalCode);
            const response = await axios.get(
                "https://maps.googleapis.com/maps/api/geocode/json",
                {
                    params: {
                        address: postalCode,
                        key: "AIzaSyCWiF-rhJC5vG-_6akKZbSiJ1AIRxJe_mI", // Use your actual API key
                    },
                }
            );
    
            if (response.data.results.length > 0) {
                const location = response.data.results[0].address_components;
                console.log("Google Maps API response:", location);
    
                const country = location.find((comp) =>
                    comp.types.includes("country")
                )?.long_name || '';
    
                if (country !== "Canada") {
                    setErrors((prev) => ({ ...prev, postalCode: "Postal code must be from Canada" }));
                    return;
                } else {
                    setErrors((prev) => ({ ...prev, postalCode: "" }));
                }
    
                const state = location.find((comp) =>
                    comp.types.includes("administrative_area_level_1")
                )?.long_name || '';
    
                const city = location.find((comp) =>
                    comp.types.includes("locality")
                )?.long_name || '';
    
                setInstituteData((prev) => ({
                    ...prev,
                    ownersData: {
                        ...prev.ownersData,
                        country,
                        province: state,
                        city,
                    },
                }));
            }
        } catch (error) {
            console.error("Error fetching location data:", error);
            setErrors((prev) => ({ ...prev, postalCode: "Error fetching location data" }));
        }
    };
    
    // const handlePostalCodeChange = async (e) => {
    //     const value = e.target.value.toUpperCase(); // Convert to uppercase for consistency
    //     const postalCodeRegex = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/; // Canadian postal code format
    
    //     setInstituteData((prev) => ({
    //         ...prev,
    //         ownersData: { ...prev.ownersData, postalCode: value },
    //     }));
    
    //     if (!postalCodeRegex.test(value)) {
    //         setErrors((prev) => ({ ...prev, postalCode: "Invalid Canadian postal code format" }));
    //         return;
    //     } else {
    //         setErrors((prev) => ({ ...prev, postalCode: "" }));
    //     }
    
    //     // Fetch location data if postal code is valid
    //     await fetchLocationData(value);
    // };


    const handlePostalCodeChange = async (e) => {
        let value = e.target.value.toUpperCase().replace(/\s+/g, ""); // Remove all spaces first
    
        // Auto-insert space after 3 characters (e.g., A1A1A1 -> A1A 1A1)
        if (value.length > 3) {
            value = value.slice(0, 3) + " " + value.slice(3);
        }
    
        const postalCodeRegex = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;
    
        setInstituteData((prev) => ({
            ...prev,
            ownersData: { ...prev.ownersData, postalCode: value },
        }));
    
        if (!postalCodeRegex.test(value)) {
            setErrors((prev) => ({
                ...prev,
                postalCode: "Invalid Canadian postal code format",
            }));
            return;
        } else {
            setErrors((prev) => ({ ...prev, postalCode: "" }));
        }
    
        await fetchLocationData(value);
    };
    
    const validateFields = () => {
        const newErrors = {};
        const { ownersData } = InstituteData;
    
        if (!ownersData.ownerIdFront || !ownersData.ownerIdBack) newErrors.ownerId = "required";
        if (!ownersData.ownerPicture) newErrors.ownerPicture = "required";
        if (!ownersData.ownerSignatureImage) newErrors.ownerSignatureImage = "required";
        if (!ownersData.contactNumber) newErrors.contactNumber = "required";
        if (!ownersData.emergencyNumber) newErrors.emergencyNumber = "required";
        if (!ownersData.emergencyEmail) newErrors.emergencyEmail = "required";
        if (!ownersData.email) newErrors.email = "required";
        if (!ownersData.FirstName) newErrors.FirstName = "required";
        if (!ownersData.LastName) newErrors.LastName = "required";
        if (!ownersData.postalCode) newErrors.postalCode = "required";
        if (!ownersData.country) newErrors.country = "required";
        if (!ownersData.province) newErrors.province = "required";
        if (!ownersData.city) newErrors.city = "required";
        if (!ownersData.Address) newErrors.Address = "required";

        // Check email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (ownersData.email && !emailRegex.test(ownersData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (ownersData.emergencyEmail && !emailRegex.test(ownersData.emergencyEmail)) {
            newErrors.emergencyEmail = "Invalid email format";
        }
    
        // Check phone format
        // const phoneRegex = /^\+1\d{10}$/;
        // if (ownersData.contactNumber && !phoneRegex.test(ownersData.contactNumber)) {
        //     newErrors.contactNumber = "Invalid phone number";
        // }
        // if (ownersData.emergencyNumber && !phoneRegex.test(ownersData.emergencyNumber)) {
        //     newErrors.emergencyNumber = "Invalid phone number";
        // }

        if (ownersData.contactNumber && ownersData.contactNumber.startsWith("+1")) {
            if (!/^\+1\d{10}$/.test(ownersData.contactNumber)) {
                newErrors.contactNumber = "Invalid Phone Number";
            }
        }

        if (ownersData.emergencyNumber && ownersData.emergencyNumber.startsWith("+1")) {
            if (!/^\+1\d{10}$/.test(ownersData.emergencyNumber)) {
                newErrors.emergencyNumber = "Invalid Phone Number";
            }
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    return (
          <div className="w-full py-[10px] lg:py-[20px] pl-[20px] lg:pl-[50px] pr-[10px] lg:pr-[50px] flex flex-col gap-[10px]">
            <p className=" w-full text-[20px] font-bold  text-[#5f56a8] md:text-[#5f56a8]	 lg:text-[20px] xl:text-[22px]">
                Partner Registration
            </p>
            <div className="w-full flex flex-col lg:flex-row justify-between">
                <div className="w-full lg:w-[50%] flex flex-col gap-[10px]">
                    <p className="text-[#1D1D1D] text-[22px] font-bold underline">
                        Attachables
                    </p>
                    <p className="text-[#625BA8] text-[16px]">
                        Upload the following documents to ensure a smooth registration process
                    </p>

                    {errors.ownerId && <span className="text-[#FF0000]"> {errors.ownerId}</span>}
                    <div className="flex w-[90%] lg:w-[82%] justify-between">
                        <p className="text-[#000000] text-[18px] ">Owner Photo ID*</p>
                        <div className="flex gap-[20px]">
                            {/* Front Photo Upload */}
                            <div className="flex flex-col gap-[5px]">
                                <input 
                                    type="file" 
                                    accept="image/*" 
                                    id="ownerIdFrontUpload" 
                                    className="hidden"
                                    onChange={(e) => handleFileChange(e, "ownerIdFront")}
                                />
                                <div 
                                    className="w-[70px] h-[51px] bg-[#F3F6F7] rounded-[9px] flex justify-center items-center cursor-pointer"
                                    style={{ border: "3px dashed #C8C8C8" }}
                                    onClick={() => document.getElementById("ownerIdFrontUpload").click()}
                                >
                                    {InstituteData.ownersData.ownerIdFront ? (
                                        <img 
                                            src={InstituteData.ownersData.ownerIdFront.previewURL} 
                                            alt="Owner ID Front Preview" 
                                            className="w-full h-full object-cover rounded-[9px]" 
                                        />
                                    ) : (
                                        <div className="w-[20px] h-[20px] rounded-full bg-[#625BA8] flex justify-center items-center">
                                            <AddIcon color="inherit" style={{ color: "white" }} />
                                        </div>
                                    )}
                                </div>
                                <p className="text-[#000000] text-[12px] text-center">Front</p>
                            </div>

                            {/* Back Photo Upload */}
                            <div className="flex flex-col gap-[5px]">
                                <input 
                                    type="file" 
                                    accept="image/*" 
                                    id="ownerIdBackUpload" 
                                    className="hidden"
                                    onChange={(e) => handleFileChange(e, "ownerIdBack")}
                                />
                                <div 
                                    className="w-[70px] h-[51px] bg-[#F3F6F7] rounded-[9px] flex justify-center items-center cursor-pointer"
                                    style={{ border: "3px dashed #C8C8C8" }}
                                    onClick={() => document.getElementById("ownerIdBackUpload").click()}
                                >
                                    {InstituteData.ownersData.ownerIdBack ? (
                                        <img 
                                            src={InstituteData.ownersData.ownerIdBack.previewURL} 
                                            alt="Owner ID Back Preview" 
                                            className="w-full h-full object-cover rounded-[9px]" 
                                        />
                                    ) : (
                                        <div className="w-[20px] h-[20px] rounded-full bg-[#625BA8] flex justify-center items-center">
                                            <AddIcon color="inherit" style={{ color: "white" }} />
                                        </div>
                                    )}
                                </div>
                                <p className="text-[#000000] text-[12px] text-center">Back</p>
                            </div>
                        </div>
                    </div>

                    {errors.ownerPicture && <span className="text-[#FF0000]"> {errors.ownerPicture}</span>}
                    <div className="flex w-full justify-between mt-[20px]">
                        <p className="text-[#000000] text-[18px] lg:w-[300px]">Owner Picture*</p>
                        <div className="flex gap-[20px]">
                            <div className="w-[140px] h-[100px] bg-[#F3F6F7] rounded-[9px]"
                            style={{
                                border:"3px dashed #C8C8C8"
                            }}>
                            {InstituteData.ownersData.ownerPicture ? (
                                <img src={InstituteData.ownersData.ownerPicture.previewURL} alt="ownerPicture Preview" className="w-full h-full object-cover rounded-[9px]" />
                            ) : null}
                            </div>
                            <input type="file" accept="image/*" id="ownerPictureUpload" className="hidden" 
                                onChange={(e) => handleFileChange(e, "ownerPicture")} />
                             <button className="h-[35px] w-[80px] bg-[#625BA8] rounded-[9px] text-[#FFFFFF] text-[16px]" 
                                    onClick={() => document.getElementById("ownerPictureUpload").click()}>
                                Browse
                            </button>
                        </div>
                    </div>

                    {errors.ownerSignatureImage && <span className="text-[#FF0000]"> {errors.ownerSignatureImage}</span>}
                    <div className="flex w-full justify-between">
                        <div className="flex flex-col">
                            <p className="text-[#000000] text-[18px]">Owner Signature</p>
                            <p className="text-[#000000] text-[12px]">(To be used on certificate)</p>
                        </div>
                        <div className="flex gap-[20px]">
                            <div className="w-[140px] h-[100px] bg-[#F3F6F7] rounded-[9px]"
                            style={{
                                border:"3px dashed #C8C8C8"
                            }}>
                                {InstituteData.ownersData.ownerSignatureImage ? (
                                    <img src={InstituteData.ownersData.ownerSignatureImage.previewURL} alt="ownerSignatureImage Preview" className="w-full h-full object-cover rounded-[9px]" />
                                ) : null}
                            </div>
                            <input type="file" accept="image/*" id="ownerSignatureImageUpload" className="hidden" 
                                onChange={(e) => handleFileChange(e, "ownerSignatureImage")} />
                             <button className="h-[35px] w-[80px] bg-[#625BA8] rounded-[9px] text-[#FFFFFF] text-[16px]" 
                                    onClick={() => document.getElementById("ownerSignatureImageUpload").click()}>
                                Browse
                            </button>
                        </div>
                    </div>

                    <p className="text-[#1D1D1D] mt-[15px] lg:mt-[0px] text-[22px] font-bold underline">
                        Contact Information
                    </p>

                    {/* Phone Number */}
                    <div className="flex flex-col gap-[5px] mt-[10px]">
                        <div className="flex w-full justify-between">
                                <label
                                    htmlFor="Email"
                                    className="text-[#000000] text-[16px]"
                                >
                                     Contact Number*
                                </label>
                                {errors.contactNumber && <span className="text-[#FF0000]"> {errors.contactNumber}</span>}
                        </div>

                        <PhoneInput  // library to automatically show the country phone code  
                            country="ca" // Automatically sets the country code
                            value={InstituteData.ownersData.contactNumber}
                            // onChange={(value) => handlePhoneNumberChange(value, "contactNumber")}
                            onChange={(value, country) => handlePhoneNumberChange(value, "contactNumber", country)}
                            inputProps={{
                            name: "PhoneNumber",
                            }}
                            containerClass={"PhoneNumberInput"}
                            inputClass={"CustomPhoneNumberInput"}
                            specialLabel={"Phone Number *"}
                            inputStyle={{
                            width: "100%",
                            height: "45px",
                            }}
                        />
                    </div>

                    {/* Emergency Contact Number */}
                    <div className="flex flex-col gap-[5px] mt-[10px]">
                        <div className="flex w-full justify-between">
                                <label
                                    htmlFor="Email"
                                    className="text-[#000000] text-[16px]"
                                >
                                     Emergency Contact Number*
                                </label>
                                {errors.emergencyNumber && <span className="text-[#FF0000]"> {errors.emergencyNumber}</span>}
                        </div>
                        <PhoneInput  // library to automatically show the country phone code  
                            country="ca" // Automatically sets the country code
                            value={InstituteData.ownersData.emergencyNumber} 
                            // onChange={(value) => handlePhoneNumberChange(value, "emergencyNumber")}
                            onChange={(value, country) => handlePhoneNumberChange(value, "emergencyNumber", country)}

                            inputProps={{
                            name: "PhoneNumber",
                            }}
                            containerClass={"PhoneNumberInput"}
                            inputClass={"CustomPhoneNumberInput"}
                            specialLabel={"Phone Number *"}
                            inputStyle={{
                            width: "100%",
                            height: "45px",
                            }}
                        />
                    </div>

                     {/* Emergency Email Address */}
                     <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label
                                    htmlFor="Email"
                                    className="text-[#000000] text-[16px]"
                                >
                                    Emergency Email Address*
                                </label>
                                {(errors.emergencyEmail || emailError) && <span className="text-[#FF0000]"> {errors.emergencyEmail || emailError} </span>}
                            </div>
                            <input type="text" name="Email" placeholder="abc@gmail.com"
                                value={InstituteData.ownersData.emergencyEmail}
                                // onChange={validateEmail}
                                onChange={(e) => validateEmailField(e, "emergencyEmail")}
                                className="w-full rounded-md py-2 px-[10px] border shadow-md" />
                     </div>

                     <p className="hidden lg:block text-[16px]"><span className="text-[#625BA8]">Note:</span> If you own multiple institutes, use the same email as your previous registration to easily manage them under one account.</p>
                </div>

                <div className="w-full lg:w-[45%] flex flex-col justify-between gap-[10px]">
                    <div className="w-full flex flex-col gap-[15px]">
                        <p className="text-[#1D1D1D] mt-[20px] lg:mt-[0px] text-[22px] font-bold underline">
                            Owner Information
                        </p>

                        {/*  Name */}
                        <div className="w-full flex gap-[10px]">
                            {/* First Name */}
                            <div className="w-[50%] flex flex-col gap-[5px]">
                                <div className="flex w-full justify-between">
                                    <label htmlFor="FirstName" className="text-[#000000] text-[16px]">
                                    First Name*
                                    </label>
                                    {errors.FirstName && <span className="text-[#FF0000]">{errors.FirstName}</span>}
                                </div>
                                <input
                                    type="text"
                                    id="FirstName"
                                    name="FirstName"
                                    placeholder="John"
                                    value={InstituteData.ownersData.FirstName}
                                    onChange={(e) => handleInputChange(e, "FirstName")}
                                    className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                                />
                            </div>

                            {/* Last Name */}
                            <div className="w-[50%] flex flex-col gap-[5px]">
                                <div className="flex w-full justify-between">
                                    <label htmlFor="LastName" className="text-[#000000] text-[16px]">
                                    Last Name*
                                    </label>
                                    {errors.LastName && <span className="text-[#FF0000]">{errors.LastName}</span>}
                                </div>
                                <input
                                    type="text"
                                    id="LastName"
                                    name="LastName"
                                    placeholder="Doe"
                                    value={InstituteData.ownersData.LastName}
                                    onChange={(e) => handleInputChange(e, "LastName")}
                                    className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                                />
                            </div>
                        </div>

                        {/* Email Address */}
                        <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="Email" className="text-[#000000] text-[16px]">
                                    Enter Email*
                                </label>
                                {errors.email && <span className="text-[#FF0000]">{errors.email}</span>}
                            </div>
                            <input
                                type="email"
                                id="Email"
                                name="email"
                                placeholder="abc@gmail.com"
                                value={InstituteData.ownersData.email}
                                onChange={(e) => validateEmailField(e, "email")}
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                            />
                        </div>

                        {/* Postal Code */}
                        <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="postalCode" className="text-[#000000] text-[16px]">
                                    Postal Code*
                                </label>
                                {errors.postalCode && <span className="text-[#FF0000]">{errors.postalCode}</span>}
                            </div>
                            <input
                                type="text"
                                id="postalCode"
                                name="postalCode"
                                placeholder="A1A 1A1"
                                value={InstituteData.ownersData.postalCode}
                                onChange={handlePostalCodeChange}
                                className={`w-full rounded-md py-2 px-[10px] ${Border} shadow-md`}
                            />
                        </div>

                        {/* Country */}
                        <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="country" className="text-[#000000] text-[16px]">
                                    Country*
                                </label>
                                {errors.country && <span className="text-[#FF0000]">{errors.country}</span>}
                            </div>
                            <SettingSelectList
                                Id="Country"
                                defaultValue=""
                                Text="Country"
                                OptionsArr={CountryOptions}
                                State={InstituteData.ownersData.country}
                                onChange={(e) => handleInputChange(e, "country")}
                            />
                        </div>

                        <div className="w-full flex gap-[10px]">
                            {/* Province */}
                            <div className="w-[50%] flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                    <label htmlFor="province" className="text-[#000000] text-[16px]">
                                        Province*
                                    </label>
                                    {errors.province && <span className="text-[#FF0000]">{errors.province}</span>}
                                </div>
                                <SettingSelectList
                                    Id="Province"
                                    defaultValue=""
                                    Text="Province / Territory"
                                    OptionsArr={ProvinceOptions}
                                    State={InstituteData.ownersData.province}
                                    onChange={(e) => handleInputChange(e, "province")}
                                />
                            </div>

                            {/* City */}
                            <div className="w-[50%] flex flex-col gap-[5px]">
                                <div className="flex w-full justify-between">
                                    <label htmlFor="city" className="text-[#000000] text-[16px]">
                                        City*
                                    </label>
                                    {errors.city && <span className="text-[#FF0000]">{errors.city}</span>}
                                </div>
                                <SettingSelectList
                                    Id="City"
                                    defaultValue=""
                                    Text="City"
                                    OptionsArr={CityOptions}
                                    State={InstituteData.ownersData.city}
                                    onChange={(e) => handleInputChange(e, "city")} 
                                />
                            </div>
                        </div>

                       {/* Address */}
                       <div className="flex flex-col gap-[5px]">
                            <div className="flex w-full justify-between">
                                <label htmlFor="address" className="text-[#000000] text-[16px]">
                                    Address*
                                </label>
                                {errors.Address && <span className="text-[#FF0000]">{errors.Address}</span>}
                                        </div>
                                        <SettingSearchLocationByInputStudent
                                        InstructorData={{ Address: InstituteData.ownersData.Address }} // Pass Address data
                                        setInstructorData={setInstituteData}
                                        EnrollmentData={{
                                            StudentData: {
                                                Country: InstituteData.ownersData.country, // Use selected country for restrictions
                                            },
                                        }}
                                        setSelectedCoordinates={setSelectedCoordinates} // Update lat/lng
                                        newCountryPostalCode={InstituteData.ownersData.country}
                                        Id="Address"
                                        addressType="Address"
                                        stateKey="ownersData"
                                    />
                            
                        </div>
                        <p className="lg:hidden text-[16px]"><span className="text-[#625BA8]">Note:</span> If you own multiple institutes, use the same email as your previous registration to link and manage them under one account.</p>

                    </div>

                    {/* max-w-[575px] */}
                    <div
                        className="submit-btn-box-shadow relative  flex w-full justify-center mt-[80px] lg:mt-auto"
                    >
                        <img
                            className="xl-top-[-62px] pointer-events-none absolute   top-[-61px] left-[60%]  w-[103px]  -translate-x-1/2 md:top-[-62px]  lg:top-[-62px] lg:w-[103px] xl:w-[103px]"
                            src={require("./Assets/Sign up Avater.png")}
                            alt=""
                        />
                        <button
                            className={`w-full cursor-pointer rounded-[8px] border-none bg-primary  py-2
                                    text-[16px] text-white  xl:py-2 
                                        xl:text-[18px]     2xl:text-base`}
                            onClick={() => {
                                if (validateFields()) {
                                    setOpenSignupScreen("PackageSelection")
                                }
                            }} 
                            //onClick={()=>setOpenSignupScreen("PackageSelection")}
                        >
                            Next
                        </button>
                    </div>

                </div>
            </div>
          </div>
    );
}

export default OwnerRegisteraion;